module cr.events {
    class MyResultController {

        gridData:any;
        runnerDetails:any;
        bibNumber:Number;
        activeItemIndex:Number;
        groupId:Number;

        static $inject = ['eventView','timingConfiguration', 'TrackingService', '$scope', '$stateParams', 'resultDetail'];

        constructor(private eventView, private timingConfiguration,  private trackingService, private $scope, private $stateParams, private resultDetail) {

            $scope.resultDetail=resultDetail;

            var results=[];
            angular.forEach(resultDetail.ResultDetails,result=>{

                var compiledResults=[];
                var config=<any>_.find(timingConfiguration.ResultGroups,resultGroup=>(<any>resultGroup).GroupId==result.GroupId)

                $scope.SelectMedia=media=>{
                    console.log("Select media: "+angular.toJson(media));
                    (<any>window).location=media.Url;
                };


                angular.forEach(config.SplitConfigurations,spltConfig=>{
                    compiledResults.push({ SplitConfig: spltConfig,Result:result.Results[spltConfig.Name] });
                    //console.log("results:"+spltConfig.Name+" - "+angular.toJson(result.Results[spltConfig.Name]) );

                });

                results.push({Config: config,Data:result,CompiledResults:compiledResults});



            });

            $scope.results=results;

            $scope.FormatPosition=(pos,status)=>{

                switch (status)
                {
                    case 1:
                        return "DSQ";

                    case 2:
                        return "DNF";

                    case 3:
                        return "DNS";

                    default:
                        return pos+".";

                }

            }

            //google.load('visualization', '1.0', {'packages':['corechart']});

        }

    }

    eventModule
        .controller('myResultController', MyResultController);


}
